module.exports = __webpack_public_path__ + "img/inside-1.784c31ec.png";